/**
 * Признак «на стенде никого нет».
 *
 * ПЕРЕХОДНЫЙ ПЕРИОД: карты называют это состояние по-разному и
 * рассчитаны на противоположное умолчание.
 *
 * | | карта прежнего образца | карта редактора |
 * |---|---|---|
 * | класс | `stand-empty` | `empty-stand` |
 * | в разметке | нет ни у кого | есть у всех стендов |
 * | приложение | добавляет пустым | снимает занятым |
 *
 * Какое слово в ходу, спрашиваем у самой карты: то, чьё правило есть в
 * её таблице стилей, и есть её словарь. Это надёжнее признаков вроде
 * набора групп — правило и есть то единственное, от чего зависит вид
 * стенда.
 *
 * Умолчание — класс редактора: новых карт со временем станет
 * большинство, а на карте, которая не описала ни того ни другого, вид
 * стенда от класса всё равно не зависит.
 *
 * Когда старых карт не останется, отсюда уходит `LEGACY_CLASS` вместе
 * с определением, и остаётся одно имя.
 */

export const EDITOR_CLASS = 'empty-stand';
export const LEGACY_CLASS = 'stand-empty';

/**
 * Каким словом эта карта называет пустой стенд.
 * @param {SVGElement} svgEl корневой <svg> открытой карты
 */
export function detectEmptyStandClass(svgEl) {
  if (!svgEl) return EDITOR_CLASS;

  const styles = [...svgEl.querySelectorAll('style')]
    .map((node) => node.textContent || '')
    .join('');

  if (styles.includes(`.${EDITOR_CLASS}`)) return EDITOR_CLASS;
  if (styles.includes(`.${LEGACY_CLASS}`)) return LEGACY_CLASS;

  return EDITOR_CLASS;
}

/**
 * Номер стенда из id элемента: `stand-9V24` → `9V24`.
 * @returns {String} пустая строка, если это не стенд
 */
export function standNumber(el) {
  if (!el || !el.id) return '';
  return el.id.startsWith('stand-') ? el.id.slice('stand-'.length) : '';
}

/**
 * Номер к виду, в котором его можно сравнивать: номера приходят из
 * разных источников, и «9 V 08» из справочника — тот же стенд, что
 * `stand-9V08` на карте.
 */
export function normalizeStandNumber(value) {
  if (typeof value !== 'string') return '';
  return value.replace(/\s+/g, '').toUpperCase();
}

/** Ставит или снимает признак пустого стенда словом этой карты. */
export function setStandEmpty(el, isEmpty, className) {
  if (!el) return;
  if (isEmpty) {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
}
